import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ErrorStateObj } from '../types/error';

export const useErrorStore = defineStore('error', () => {
    const errorStateData = ref<ErrorStateObj | null>(null);

    const setError = (messageObj: ErrorStateObj) => {
        errorStateData.value = {
            ...messageObj,
        };
    };

    const clearError = () => {
        errorStateData.value = null;
    };

    return {
        errorStateData,
        setError,
        clearError,
    };
});

export default useErrorStore;
